import styled from 'styled-components';

import theme from '$/assets/theme';

const StyledIcon = styled.div<{
  background: 'grey1' | 'brandGreen';
  color: 'white' | 'grey7';
  cursor?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${(props) => theme.colors[props.background]};
  color: ${(props) => theme.colors[props.color]};
  cursor: ${(props) => props.cursor};
`;

export default StyledIcon;
